import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { useStripePortal } from '@/composables/useStripePortal'
import { resolvePaywallRedirect } from '@/utils/paywallLogic'

export const usePaywallStore = defineStore('paywall', () => {
  const isPaywall = ref(false)
  const paywallText = ref('')
  const userStore = useUserStore()
  const { redirectToPortal } = useStripePortal()

  const redirectContactOrStripe = () => {
    const accountType = userStore.user.organisation.accountType
    const hasStripeCustomer =
      userStore.subscriptionStatus?.hasStripeCustomer ??
      !!userStore.user.organisation.stripeCustomerID

    const target = resolvePaywallRedirect({
      isOrgaAdmin: userStore.isOrgaAdmin,
      accountType: accountType ?? '',
      hasStripeCustomer
    })

    if (target === 'contact') return (window.location.href = 'https://newsrooms.ai/contact')
    if (target === 'portal') return redirectToPortal()
    return (window.location.href = '/checkout')
  }

  const redirectProductPage = () => {
    return (window.location.href = 'https://newsrooms.ai/contact')
  }
  const triggerPaywall = (text?: string) => {
    isPaywall.value = true
    paywallText.value =
      text ||
      'You have reached the limit of your license. Please contact your administrator to upgrade your license.'
  }

  const getCookie = (name: string) => {
    // eslint-disable-next-line security/detect-non-literal-regexp
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
    return match ? decodeURIComponent(match[1]) : undefined
  }
  const setCookie = (name: string, value: string, expires: Date) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`
  }

  const checkAndSetTranscribeCookie = () => {
    if (getCookie('hasUsedTranscription')) {
      return true
    } else {
      setCookie('hasUsedTranscription', 'true', new Date(Date.now() + 30 * 24 * 60 * 5 * 1000))
      return false
    }
  }
  const checkAndSetFileExtractionCookie = () => {
    if (getCookie('hasUsedFileExtraction')) {
      return true
    } else {
      setCookie('hasUsedFileExtraction', 'true', new Date(Date.now() + 30 * 24 * 60 * 5 * 1000))
      return false
    }
  }
  return {
    triggerPaywall,
    isPaywall,
    paywallText,
    redirectProductPage,
    redirectContactOrStripe,
    checkAndSetTranscribeCookie,
    checkAndSetFileExtractionCookie
  }
})
